import "./WorkVisas.module.css";
import Header from "@/reusable_sections/Header";
import HeroBanner from "./sections/HeroBanner";
import EmergencySituationsGrid from "./sections/EmergencySituationsGrid";
import ContactOurExpertTeam from "./sections/ContactOurExpertTeam";
import Footer from "@/reusable_sections/Footer";
export default function WorkVisasPage() {
  return <div>
      <Header />
      <HeroBanner />
      <EmergencySituationsGrid />
      <ContactOurExpertTeam />
      <Footer />
    </div>;
}